import axios from 'axios'
import globalConfig from '../config/globle.config'
import requestHeader from '../utils/requestHeader'
import store from '../router'
import notification from 'ant-design-vue/es/notification'
import message from 'ant-design-vue/es/message'

const newRequest = axios.create({
  baseURL: globalConfig.rootUrl,
  timeout: 180000,
})

newRequest.interceptors.request.use((config) => {
  return config
})

newRequest.interceptors.response.use(
  (response) => {
    const { request, status, data } = response
    console.log('request.responseType', request.responseType)
    if (status !== 200) {
      notification.error({
        message: '错误',
        description: '服务器异常',
      })
      return Promise.reject(data)
    }
    if (request.responseType !== 'blob' && data.code == 401) {
      store.push('login')
      return Promise.reject(data)
    } else if (request.responseType !== 'blob' && data.code == -1) {
      notification.error({
        message: '错误',
        description: '服务器异常',
      })
      return Promise.reject(data)
    } else if (request.responseType !== 'blob' && data.code != 0) {
      console.log('newrequest--!= 0')
      message.error(data.msg)
      return Promise.reject(data)
    } else {
      console.log('newrequest-- else')
      return Promise.resolve(data)
    }
  },
  (error) => {
    notification.error({
      message: '错误',
      description: error.message,
    })
  }
)

export default newRequest
